export default __webpack_public_path__ + "static/media/Education.aed020b6.svg";